import { makeActionCreator } from '../../config/store/utils'
import { getSectorsByProviders, createComparatorTradedBy } from '../../services/comparatorCharts'
import theme from '../../config/styles/theme'

export const COMPARATOR_TRADED_SECTORS = 'COMPARATOR_TRADED_SECTORS'
export const COMPARATOR_TRADED_SECTORS_ERROR = 'COMPARATOR_TRADED_SECTORS_ERROR'
export const COMPARATOR_TRADED_SECTORS_SUCCESS = 'COMPARATOR_TRADED_SECTORS_SUCCESS'
export const onComparatorTradedSector = makeActionCreator(COMPARATOR_TRADED_SECTORS)
export const onComparatorTradedSectorError = makeActionCreator(COMPARATOR_TRADED_SECTORS_ERROR, 'payload')
export const onComparatorTradedSectorSuccess = makeActionCreator(COMPARATOR_TRADED_SECTORS_SUCCESS, 'payload')
export const onComparatorTradedSectorThunk =
  ({ year, idEntity }) =>
  async dispatch => {
    dispatch(onComparatorTradedSector())

    try {
      const response = await getSectorsByProviders({ year, idEntity })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorTradedSectorError(response.data.errores))
      }

      const payload = response.data.payload[0].data.map(sector => ({
        name: sector.categoryName,
        value: sector.idCategory
      }))

      return dispatch(onComparatorTradedSectorSuccess(payload))
    } catch (error) {
      return dispatch(onComparatorTradedSectorError(error))
    }
  }

export const COMPARATOR_TRADED_BY = 'COMPARATOR_TRADED_BY'
export const COMPARATOR_TRADED_BY_ERROR = 'COMPARATOR_TRADED_BY_ERROR'
export const COMPARATOR_TRADED_BY_SUCCESS = 'COMPARATOR_TRADED_BY_SUCCESS'
export const onComparatorTradedBy = makeActionCreator(COMPARATOR_TRADED_BY)
export const onComparatorTradedByError = makeActionCreator(COMPARATOR_TRADED_BY_ERROR, 'payload')
export const onComparatorTradedBySuccess = makeActionCreator(COMPARATOR_TRADED_BY_SUCCESS, 'payload')
export const onComparatorTradedByThunk =
  ({ year, idEntity, category }) =>
  async dispatch => {
    dispatch(onComparatorTradedBy())

    try {
      const response = await createComparatorTradedBy({ year, idEntity, category })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorTradedByError(response.data.errores))
      }

      // Entities
      const firstEntity = response.data.payload[0].data1[0] || {}
      const secondEntity = response.data.payload[0].data2[0] || {}
      const categories = [firstEntity?.name, secondEntity?.name]
      const firstAmountData = {
        color: theme.palette.charts.navyBlue,
        name: firstEntity?.name,
        y: firstEntity.montoN1CLP || 0
      }
      const secondAmountData = {
        color: theme.palette.charts.darkRed,
        name: secondEntity?.name,
        y: secondEntity.montoN1CLP || 0
      }
      // CSV
      const csvStructure = [
        ['Año', 'Rubro', 'Organismo', 'Monto (CLP)'],
        [year, firstEntity.categoryName, firstAmountData.name, firstAmountData.y],
        [year, secondEntity.categoryName, secondAmountData.name, secondAmountData.y]
      ]
      const payload = {
        categories,
        csvStructure,
        amounts: [firstAmountData, secondAmountData]
      }

      return dispatch(onComparatorTradedBySuccess(payload))
    } catch (error) {
      return dispatch(onComparatorTradedByError(error))
    }
  }
